import React, { Component } from 'react';
import axios from 'axios';
import Container from '@material-ui/core/Container';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import LinearProgress from '@material-ui/core/LinearProgress';
import RefreshIcon from '@material-ui/icons/Refresh';

import { Button, Grid, withStyles, Typography } from '@material-ui/core';
import { API_URL, EVENT_ID } from '../../constants';

const BorderLinearProgress = withStyles((theme) => ({
  root: {
    height: 20,
    // borderRadius: 5,
    margin: '7px 0 15px',
  },
  colorPrimary: {
    backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
  },
  bar: {
    // borderRadius: 5,
    backgroundColor: '#b362b7',
  },
}))(LinearProgress);

const styles = (theme) => ({
  selectBtn: {
    width: '50px',
    height: '50px',
    backgroundColor: '#adadad',
    borderRadius: '3px',
    display: 'flex',
  },
  radioBtn: {
    opacity: 0,
    position: 'absolute',
    width: '50px',
    height: '50px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  radioLabel: {
    width: '50px',
    height: '50px',
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '18px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  voteCnt: {
    position: 'absolute',
    right: 0,
    color: '#828282',
    fontSize: '14px',
  },
});

class VoteRes extends Component {
  //투표결과 불러오기 -> 사용자가 투표 완료한 시점에서 불러와야된다
  getVoteResult = async () => {
    try {
      axios
        .get(`${API_URL}/voting/result?evt=${EVENT_ID}&voting=${this.props.voteId}`, {
          headers: { Pragma: 'no-cache' },
        })
        .then((res) => {
          // console.log(res);
          if (res.data) {
            this.setState({
              totalCnt: res.data.total,
              res1: res.data.val1,
              res2: res.data.val2,
              res3: res.data.val3,
              res4: res.data.val4,
              res5: res.data.val5,
              // res6: res.data.val6,
            });
            // if (res.data.val3) {
            //   this.setState({ res3: res.data.val3 });
            // }
            // if (res.data.val4) {
            //   this.setState({ res4: res.data.val4 });
            // }
            // if (res.data.val5) {
            //   this.setState({ res5: res.data.val5 });
            // }
          }
        });
    } catch (e) {
      console.error(e);
    }
  };

  componentDidMount() {
    // console.log("이벤트아이디: " + EVENT_ID);
    // console.log("채널: " + this.props.channel);
    // console.log("세션아이디: " + this.state.pgmId);

    this.getVoteResult();
    // 보팅 안한화면

    // console.log("문항갯수: " + this.state.voteCnt);

    //setTimeout(() => this.getVoteResult(), 200);
  }

  constructor(props) {
    super(props);

    this.state = {
      pgmId: sessionStorage.getItem('_in_session'),
      isVoted: false,
      selected: null,
      itemList: [],
      voteCnt: this.props.count,
      totalCnt: 0,
      res1: 0,
      res2: 0,
      res3: 0,
      res4: 0,
      res5: 0,
      // res6: 0,
    };
  }

  voteReset() {
    // this.setState({ totalCnt: 0, res1: 0, res2: 0, res3: 0, res4: 0, res5: 0, res6: 0, voteCnt: 6 });
    this.setState({ totalCnt: 0, res1: 0, res2: 0, res3: 0, res4: 0, res5: 0, voteCnt: 5 });
  }

  normalise(value) {
    return ((value - 0) * 100) / (this.state.totalCnt - 0);
  }

  render() {
    const { classes } = this.props;

    return (
      <Container style={{ height: '100%' }}>
        <div style={{ textAlign: 'right', marginBottom: '0.5em' }}>
          <Button onClick={() => this.getVoteResult()}>
            <RefreshIcon />
          </Button>
          {/*
          <Button
            onClick={() => {
              console.log("reset");
              this.voteReset();
            }}
          >
            리셋
          </Button>
          */}
        </div>

        <FormControl style={{ minWidth: '100%' }}>
          <RadioGroup>
            <Grid container spacing={2}>
              {/* {this.props.exList.map((item, i) => {
                let getRes = "res" + Number(i + 1);
                return (
                  <Grid item container xs={12} style={{ padding: 0 }}>
                    <Grid item>
                      <div className={classes.selectBtn}>
                        <Radio disabled value={i + 1} id={i + 1} className={classes.radioBtn} />
                        <label htmlFor={i + 1} className={classes.radioLabel}>
                          {i + 1}
                        </label>
                      </div>
                    </Grid>
                    <Grid item alignItems={"center"} style={{ display: "flex" }}>
                      <Typography display={"inline"} style={{ paddingLeft: "1em" }}>
                        {i + 1}번
                      </Typography>
                      <Typography display={"inline"} className={classes.voteCnt}>
                        {this.state[getRes]}/{this.state.totalCnt}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} style={{ padding: "0 0 8px" }}>
                      <BorderLinearProgress variant="determinate" value={normalise(this.state[getRes])} />
                    </Grid>
                  </Grid>
                );
              })} */}

              <Grid item container xs={12} style={{ padding: 0 }}>
                <Grid item>
                  <div className={classes.selectBtn}>
                    <Radio disabled value={1} id={1} className={classes.radioBtn} />
                    <label htmlFor={1} className={classes.radioLabel}>
                      1
                    </label>
                  </div>
                </Grid>
                <Grid item alignItems={'center'} style={{ display: 'flex' }}>
                  <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                    1번
                  </Typography>
                  <Typography display={'inline'} className={classes.voteCnt}>
                    {this.state.res1}/{this.state.totalCnt}
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                  <BorderLinearProgress variant="determinate" value={this.normalise(this.state.res1)} />
                </Grid>
              </Grid>
              <Grid item container xs={12} style={{ padding: 0 }}>
                <Grid item>
                  <div className={classes.selectBtn}>
                    <Radio disabled value={2} id={2} className={classes.radioBtn} />
                    <label htmlFor={2} className={classes.radioLabel}>
                      2
                    </label>
                  </div>
                </Grid>
                <Grid item alignItems={'center'} style={{ display: 'flex' }}>
                  <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                    2번
                  </Typography>
                  <Typography display={'inline'} className={classes.voteCnt}>
                    {this.state.res2}/{this.state.totalCnt}
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                  <BorderLinearProgress variant="determinate" value={this.normalise(this.state.res2)} />
                </Grid>
              </Grid>
              {this.state.voteCnt > 2 ? (
                <Grid item container xs={12} style={{ padding: 0 }}>
                  <Grid item>
                    <div className={classes.selectBtn}>
                      <Radio disabled value={3} id={3} className={classes.radioBtn} />
                      <label htmlFor={3} className={classes.radioLabel}>
                        3
                      </label>
                    </div>
                  </Grid>
                  <Grid item alignItems={'center'} style={{ display: 'flex' }}>
                    <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                      3번
                    </Typography>
                    <Typography display={'inline'} className={classes.voteCnt}>
                      {this.state.res3}/{this.state.totalCnt}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                    <BorderLinearProgress variant="determinate" value={this.normalise(this.state.res3)} />
                  </Grid>
                </Grid>
              ) : (
                ''
              )}
              {this.state.voteCnt > 3 ? (
                <Grid item container xs={12} style={{ padding: 0 }}>
                  <Grid item>
                    <div className={classes.selectBtn}>
                      <Radio disabled value={4} id={4} className={classes.radioBtn} />
                      <label htmlFor={4} className={classes.radioLabel}>
                        4
                      </label>
                    </div>
                  </Grid>
                  <Grid item alignItems={'center'} style={{ display: 'flex' }}>
                    <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                      4번
                    </Typography>
                    <Typography display={'inline'} className={classes.voteCnt}>
                      {this.state.res4}/{this.state.totalCnt}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                    <BorderLinearProgress variant="determinate" value={this.normalise(this.state.res4)} />
                  </Grid>
                </Grid>
              ) : (
                ''
              )}
              {this.state.voteCnt > 4 ? (
                <Grid item container xs={12} style={{ padding: 0 }}>
                  <Grid item>
                    <div className={classes.selectBtn}>
                      <Radio disabled value={5} id={5} className={classes.radioBtn} />
                      <label htmlFor={5} className={classes.radioLabel}>
                        5
                      </label>
                    </div>
                  </Grid>
                  <Grid item alignItems={'center'} style={{ display: 'flex' }}>
                    <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                      5번
                    </Typography>
                    <Typography display={'inline'} className={classes.voteCnt}>
                      {this.state.res5}/{this.state.totalCnt}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                    <BorderLinearProgress variant="determinate" value={this.normalise(this.state.res5)} />
                  </Grid>
                </Grid>
              ) : (
                ''
              )}
              {/* {this.state.voteCnt > 5 ? (
                <Grid item container xs={12} style={{ padding: 0 }}>
                  <Grid item>
                    <div className={classes.selectBtn}>
                      <Radio disabled value={6} id={6} className={classes.radioBtn} />
                      <label htmlFor={6} className={classes.radioLabel}>
                        6
                      </label>
                    </div>
                  </Grid>
                  <Grid item alignItems={'center'} style={{ display: 'flex' }}>
                    <Typography display={'inline'} style={{ paddingLeft: '1em' }}>
                      6번
                    </Typography>
                    <Typography display={'inline'} className={classes.voteCnt}>
                      {this.state.res6}/{this.state.totalCnt}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} style={{ padding: '0 0 8px' }}>
                    <BorderLinearProgress variant="determinate" value={this.normalise(this.state.res6)} />
                  </Grid>
                </Grid>
              ) : (
                ''
              )} */}
            </Grid>
          </RadioGroup>
        </FormControl>
      </Container>
    );
  }
}

export default withStyles(styles)(VoteRes);
